import React, { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import Image from 'next/image';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import { twJoin, twMerge } from 'tailwind-merge';
import { ManufacturerSelectProps } from './types/ManufacturerSelectProps';

function ManufacturerSelect({
  heading,
  options,
  selectedOption,
  onChange,
}: ManufacturerSelectProps) {
  return (
    <div className="mt-10">
      {heading && <RichTextRenderer className="text-2xl" blocks={heading} />}
      <div className="relative">
        <Listbox value={selectedOption} onChange={onChange}>
          {({ open }) => (
            <>
              <Listbox.Button
                className={twMerge(
                  'mt-4 flex w-full items-center justify-between rounded-md border border-neutral-10 bg-white p-4 focus-within:border-neutral-100 focus:outline-none',
                  open && 'border-neutral-100',
                )}
                aria-haspopup="listbox"
                aria-expanded={open}
              >
                {selectedOption?.key}
                <Image
                  src="/images/polygon.svg"
                  alt="Polygon expand dropdown"
                  className={twJoin('duration-200 ease-in', open && 'rotate-180')}
                  width={24}
                  height={24}
                />
              </Listbox.Button>
              <Transition
                as={Fragment}
                enterFrom="opacity-0"
                enterTo="opacity-100"
                enter="transition ease-out duration-200"
                leave="transition ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options className="absolute w-full rounded-md border border-neutral-10 bg-white">
                  {options.map((option, i) => (
                    <Listbox.Option
                      key={i}
                      value={option}
                      className={({ active, selected }) =>
                        twMerge(
                          'rounded-xs px-2 py-1 text-neutral-70 duration-100 ease-in hover:cursor-pointer',
                          active ? 'bg-neutral-5 text-neutral-100' : '',
                          selected ? 'font-bold' : '',
                        )}
                      aria-selected={selectedOption?.key === option.key}
                    >
                      {option.key}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </>
          )}
        </Listbox>
      </div>
    </div>
  );
}

export default ManufacturerSelect;
